import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRibbon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 509,
	height: 803,
	viewBox: "0 0 509 803",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M49.7036 766.099C49.7036 766.099 194.445 567.461 242.204 489.039C409.293 271.738 404.205 61.5001 251.921 61.5001C99.638 61.5001 99.6829 279.228 232.528 457.044C399.813 680.958 458.168 766.099 458.168 766.099",
		stroke: "#FF8B7C",
		strokeWidth: 123
	})
});
export default SvgRibbon;
